import React from "react";

const MIN_YEAR = 1900;
const CURRENT_YEAR = new Date().getFullYear();
const YEAR_OPTIONS = Array.from(
  { length: CURRENT_YEAR - MIN_YEAR + 1 },
  (_, i) => CURRENT_YEAR - i,
);

const makeCustomHeader =
  (onPick, monthNames) =>
  ({
    date,
    changeYear,
    changeMonth,
    decreaseMonth,
    increaseMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled,
  }) => {
    const commitDate = (updater) => {
      const base = date ? new Date(date) : new Date();
      updater(base);
      onPick(base);
    };

    return (
      <div className="datepicker-custom-header">
        <button
          type="button"
          onClick={decreaseMonth}
          disabled={prevMonthButtonDisabled}
          className="datepicker-nav-btn"
        >
          {"<"}
        </button>

        <select
          value={date ? date.getMonth() : new Date().getMonth()}
          onChange={({ target: { value } }) => {
            const month = Number(value);
            changeMonth(month);
            commitDate((d) => d.setMonth(month));
          }}
          className="datepicker-select"
        >
         {monthNames.map((month, i) => (
            <option key={month} value={i}>
              {month}
            </option>
          ))}
        </select>

        <select
          value={date ? date.getFullYear() : new Date().getFullYear()}
          onChange={({ target: { value } }) => {
            const year = Number(value);
            changeYear(year);
            commitDate((d) => d.setFullYear(year));
          }}
          className="datepicker-select"
        >
          {YEAR_OPTIONS.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>

        <button
          type="button"
          onClick={increaseMonth}
          disabled={nextMonthButtonDisabled}
          className="datepicker-nav-btn"
        >
          {">"}
        </button>
      </div>
    );
  };

export default makeCustomHeader;